module.exports = __webpack_public_path__ + "assets/img/wechat-qrcode.280f8a6a.jpg";